// import { jwtDecode } from "jwt-decode";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { validateStoredUser } from "../../store/slices/userSlice";
import type { AppDispatch } from "../../store/store";
import { setActiveWorkspaceFromToken } from "../../store/slices/workspaceSlice";

const TokenReceiver: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (
        event.origin === "https://auth.stage.pulselabs.ai" ||
        event.origin === "https://auth.pulselabs.ai"
      ) {
        const token = event.data.token;
        const workspaceId = event.data.workspaceId;
        console.log("workspace", event.data);

        if (token) {
          try {
            dispatch(validateStoredUser(token)).unwrap();
            if (workspaceId) {
              dispatch(
                setActiveWorkspaceFromToken({
                  workspaceId: workspaceId,
                  token: token,
                }),
              );
            }
          } catch (error) {
            console.error("Failed to validate user:", error);
          }
          console.log("Token and workspace received:", { token, workspaceId });
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [dispatch]);

  return null;
};

export default TokenReceiver;
